module.exports = __webpack_public_path__ + "img/mapImg.44ce281f.png";